import { GET_FOOTER_LINKS } from '../constants/ActionTypes';

export function getFooterLinks() {
  return {
    type: GET_FOOTER_LINKS,
    request: {
      op: 'get',
      path: '/@linksrodape',
    },
  };
}
